<template>
  <div id="contenedor-contrato-ubicaciones">
    <v-card
      flat>
      <v-data-table
        :headers="headers"
        :items="getContratoUbicaciones"
        hide-default-footer>
        <template v-slot:[`item.acciones`]="{ item }">
          <v-tooltip
            top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="editar(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip
            top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="borrar(item)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Borrar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog
      v-model="mostrarEditarUbicacion"
      width="650"
      persistent
      v-if="estaUbicacion">
      <editar-contrato-ubicacion
        :ubicacion-editar="estaUbicacion"
        v-on:cerrar="cerrarUbicacion">
      </editar-contrato-ubicacion>
    </v-dialog>
    <v-dialog
      v-model="mostrarBorrarUbicacion"
      width="500"
      persistent
      v-if="estaUbicacion">
      <borrar-contrato-ubicacion
        :ubicacion-editar="estaUbicacion"
        v-on:cerrar="cerrarUbicacion">
      </borrar-contrato-ubicacion>
    </v-dialog>
  </div>
</template>

<script>
import CONTRATO_UBICACIONES from '@/graphql/querys/administracion/contratos/ubicaciones/contratoUbicaciones.gql';
import mixContratoUbicaciones from '@/components/administracion/contratos/contrato/ubicaciones/mixContratoUbicaciones';
import EditarContratoUbicacion from '@/components/administracion/contratos/contrato/ubicaciones/Editar.vue';
import BorrarContratoUbicacion from '@/components/administracion/contratos/contrato/ubicaciones/Eliminar.vue';

export default {
  name: 'ContratoUbicaciones',
  mixins: [mixContratoUbicaciones],
  components: {
    EditarContratoUbicacion,
    BorrarContratoUbicacion,
  },
  props: {
    idContrato: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      estaUbicacion: null,
      mostrarEditarUbicacion: false,
      mostrarBorrarUbicacion: false,
      headers: [
        {
          text: 'Lat punto [A]',
          align: 'start',
          sortable: false,
          value: 'latitudPuntoA',
        },
        { text: 'Lgn punto [A]', value: 'longitudPuntoA' },
        { text: 'Lat punto [B]', value: 'latitudPuntoB' },
        { text: 'Lgn punto [B]', value: 'longitudPuntoB' },
        {
          text: '', align: 'end', width: '150', value: 'acciones',
        },
      ],
    };
  },
  methods: {
    editar(ubicacion) {
      this.estaUbicacion = ubicacion;
      this.mostrarEditarUbicacion = true;
    },
    borrar(ubicacion) {
      this.estaUbicacion = ubicacion;
      this.mostrarBorrarUbicacion = true;
    },
    cerrarUbicacion() {
      this.estaUbicacion = null;
      this.mostrarEditarUbicacion = false;
      this.mostrarBorrarUbicacion = false;
    },
  },
  apollo: {
    contratoUbicaciones: {
      query: CONTRATO_UBICACIONES,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
  },
  computed: {
    getContratoUbicaciones() {
      if (!this.contratoUbicaciones) return [];
      return this.contratoUbicaciones;
    },
  },
};
</script>

<style lang="scss">

</style>
